exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ContactCard-action--Z-oV{float:right}.ContactCard-name-yfdLQ{padding:10px 0}.ContactCard-name-yfdLQ h5{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.ContactCard-detail-1ucX8{min-height:146px;padding:10px 12px;border-top:1px solid #d6dde1;background:#fbfbfb}.ContactCard-contact-3olOR{margin:0;padding:0;list-style-type:none}.ContactCard-contact-3olOR>li{display:inline-block;margin:5px 20px 5px 0}.ContactCard-contact-3olOR>li.ContactCard-mail-3nSpM{display:block;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}", ""]);

// exports
exports.locals = {
	"action": "ContactCard-action--Z-oV",
	"name": "ContactCard-name-yfdLQ",
	"detail": "ContactCard-detail-1ucX8",
	"contact": "ContactCard-contact-3olOR",
	"mail": "ContactCard-mail-3nSpM"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[name]-[local]-[hash:base64:5]!./~/autoprefixer-loader!./~/less-loader!./lib/patrimony/components/ContactCard.less
// module id = 1679
// module chunks = 0